import React, { useState } from 'react';
import { db } from '../firebaseConfig';
import { collection, getDocs, writeBatch, doc } from 'firebase/firestore';
import Swal from 'sweetalert2';

export default function AgregarCampoTipo() {
  const [loading, setLoading] = useState(false);
  const [stats, setStats] = useState({
    asesoresTotal: 0,
    asesoresActualizados: 0,
    asociadosTotal: 0,
    asociadosActualizados: 0
  });
  const [log, setLog] = useState<string[]>([]);

  const addLog = (mensaje: string) => {
    console.log(mensaje);
    setLog(prev => [...prev, mensaje]);
  };

  const agregarCampo = async () => {
    const result = await Swal.fire({
      title: '¿Agregar campo "tipo"?',
      html: `
        <p>Este proceso agregará el campo <code>tipo</code> a todos los documentos de asesores y asociados.</p>
        <p><strong>Campo a agregar:</strong></p>
        <ul style="text-align: left;">
          <li>Asesores: <code>tipo: 'asesor'</code></li>
          <li>Asociados: <code>tipo: 'asociado'</code></li>
        </ul>
        <p>Este campo es necesario para que el sistema de autenticación reconozca el rol del usuario.</p>
      `,
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Sí, agregar',
      cancelButtonText: 'Cancelar',
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33'
    });

    if (!result.isConfirmed) return;

    setLoading(true);
    setLog([]);

    try {
      addLog('🔧 Iniciando actualización de documentos...');
      addLog('');

      // Actualizar asesores
      addLog('📝 Actualizando asesores...');
      const asesoresSnapshot = await getDocs(collection(db, 'asesor'));
      const totalAsesores = asesoresSnapshot.size;

      setStats(prev => ({ ...prev, asesoresTotal: totalAsesores }));
      addLog(`   Total asesores encontrados: ${totalAsesores}`);

      let batch = writeBatch(db);
      let operacionesEnBatch = 0;
      let asesoresActualizados = 0;

      for (const asesorDoc of asesoresSnapshot.docs) {
        const data = asesorDoc.data();

        // Solo actualizar si no tiene el campo tipo o es incorrecto
        if (!data.tipo || data.tipo !== 'asesor') {
          const asesorRef = doc(db, 'asesor', asesorDoc.id);
          batch.update(asesorRef, { tipo: 'asesor' });
          operacionesEnBatch++;
          asesoresActualizados++;

          if (operacionesEnBatch >= 500) {
            await batch.commit();
            batch = writeBatch(db);
            operacionesEnBatch = 0;
            addLog(`   ✅ Batch commit: ${asesoresActualizados} asesores actualizados`);
          }
        }
      }

      if (operacionesEnBatch > 0) {
        await batch.commit();
        addLog(`   ✅ Batch final: ${asesoresActualizados} asesores actualizados`);
      }

      setStats(prev => ({ ...prev, asesoresActualizados }));
      addLog(`✅ Asesores actualizados: ${asesoresActualizados}`);
      addLog('');

      // Actualizar asociados
      addLog('📝 Actualizando asociados...');
      const asociadosSnapshot = await getDocs(collection(db, 'asociado'));
      const totalAsociados = asociadosSnapshot.size;

      setStats(prev => ({ ...prev, asociadosTotal: totalAsociados }));
      addLog(`   Total asociados encontrados: ${totalAsociados}`);

      batch = writeBatch(db);
      operacionesEnBatch = 0;
      let asociadosActualizados = 0;

      for (const asociadoDoc of asociadosSnapshot.docs) {
        const data = asociadoDoc.data();

        // Solo actualizar si no tiene el campo tipo o es incorrecto
        if (!data.tipo || data.tipo !== 'asociado') {
          const asociadoRef = doc(db, 'asociado', asociadoDoc.id);
          batch.update(asociadoRef, { tipo: 'asociado' });
          operacionesEnBatch++;
          asociadosActualizados++;

          if (operacionesEnBatch >= 500) {
            await batch.commit();
            batch = writeBatch(db);
            operacionesEnBatch = 0;
            addLog(`   ✅ Batch commit: ${asociadosActualizados} asociados actualizados`);
          }
        }
      }

      if (operacionesEnBatch > 0) {
        await batch.commit();
        addLog(`   ✅ Batch final: ${asociadosActualizados} asociados actualizados`);
      }

      setStats(prev => ({ ...prev, asociadosActualizados }));
      addLog(`✅ Asociados actualizados: ${asociadosActualizados}`);
      addLog('');

      addLog('✅ PROCESO COMPLETADO');

      Swal.fire({
        icon: 'success',
        title: '¡Actualización completada!',
        html: `
          <div style="text-align: left;">
            <p><strong>Resumen:</strong></p>
            <ul>
              <li>Asesores actualizados: ${asesoresActualizados} de ${totalAsesores}</li>
              <li>Asociados actualizados: ${asociadosActualizados} de ${totalAsociados}</li>
            </ul>
            <p>Ahora recarga la página (F5) e intenta acceder al dashboard.</p>
          </div>
        `,
        confirmButtonColor: '#3085d6'
      });

    } catch (error: any) {
      console.error('Error al actualizar documentos:', error);
      addLog('');
      addLog(`❌ ERROR: ${error.message}`);

      Swal.fire({
        icon: 'error',
        title: 'Error al actualizar',
        text: error.message,
        confirmButtonColor: '#d33'
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ padding: '40px', maxWidth: '1200px', margin: '0 auto' }}>
      <h1>🔧 Agregar Campo "tipo" a Asesores y Asociados</h1>

      <div style={{
        backgroundColor: '#f8f9fa',
        padding: '20px',
        borderRadius: '8px',
        marginBottom: '20px',
        border: '1px solid #dee2e6'
      }}>
        <h3>📋 Información</h3>
        <p>
          Este componente agregará el campo <code>tipo</code> a todos los documentos de las colecciones
          <code>asesor</code> y <code>asociado</code>.
        </p>
        <p>
          <strong>Este campo es necesario para:</strong>
        </p>
        <ul>
          <li>Que el sistema de autenticación reconozca el rol del usuario</li>
          <li>Que la función <code>resolverRol()</code> pueda asignar correctamente AFILIADO o ASOCIADO</li>
          <li>Permitir el acceso al dashboard y otras páginas protegidas</li>
        </ul>
      </div>

      {stats.asesoresTotal > 0 || stats.asociadosTotal > 0 ? (
        <div style={{
          backgroundColor: '#d1ecf1',
          padding: '15px',
          borderRadius: '8px',
          marginBottom: '20px',
          border: '1px solid #bee5eb'
        }}>
          <h4>📊 Estadísticas</h4>
          <p><strong>Asesores:</strong> {stats.asesoresActualizados} de {stats.asesoresTotal} actualizados</p>
          <p><strong>Asociados:</strong> {stats.asociadosActualizados} de {stats.asociadosTotal} actualizados</p>
        </div>
      ) : null}

      <button
        onClick={agregarCampo}
        disabled={loading}
        style={{
          backgroundColor: loading ? '#6c757d' : '#007bff',
          color: 'white',
          padding: '12px 30px',
          border: 'none',
          borderRadius: '5px',
          fontSize: '16px',
          cursor: loading ? 'not-allowed' : 'pointer',
          marginBottom: '20px'
        }}
      >
        {loading ? '⏳ Actualizando...' : '▶️ Agregar Campo "tipo"'}
      </button>

      {log.length > 0 && (
        <div style={{
          backgroundColor: '#000',
          color: '#0f0',
          padding: '20px',
          borderRadius: '8px',
          fontFamily: 'monospace',
          fontSize: '14px',
          maxHeight: '500px',
          overflowY: 'auto',
          whiteSpace: 'pre-wrap'
        }}>
          {log.map((line, idx) => (
            <div key={idx}>{line}</div>
          ))}
        </div>
      )}
    </div>
  );
}
